export const mainAuthContainer = {
  minHeight: "100vh",
  w: "100vw",
  alignItems: "center",
  justifyContent: "center",
  overflowY: "hidden",
  flexDirection: "column",
  gap: "1rem",
};

export const authBox = {
  p: 8,
  mx: "auto",
  maxW: "400px",
  w: "90%",
  borderWidth: 1,
  borderRadius: "md",
  overflow: "hidden",
  minW: "300px",
};

export const loginBottomBox = {
  color: "blue.500",
  fontWeight: "bold",
  textAlign: "center",
  cursor: "pointer",
  _hover: { color: "gray" },
  padding: "1rem",
  borderRadius: 0,
};

export const loginConfirmCodebtn = {
  w: "100%",
  color: "white",
  borderRadius: "12px",
  mb: "4rem",
};

export const resetPasswordBtn = {
  width: "100%",
  color: "white",
  borderRadius: "12px",
  mt: "2rem",
};

export const authSmallText = {
  textAlign: "center",
  mb: "5",
  color: "gray",
  fontSize: "0.9rem",
  fontWeight: "400",
};

export const loginLogosStyle = {
  color: "gray",
  m: "auto",
  my: "4",
  fontSize: "8rem",
  textAlign: "center",
};

export const signupHeadingStyle = {
  fontFamily: "Pacifico, cursive",
  title: "InstaVerse",
  align: "center",
  my: "4",
};

export const signUpFormSmText = {
  textAlign: "center",
  margin: "1rem 0",
  padding: "0 1rem",
  color: "gray",
};

export const codeSentLinkStyle = {
  display: "inline",
  cursor: "pointer",
  _hover: { color: "gray" },
  color: "blue.500",
  fontWeight: "bold",
};

export const signupGoBackBtnStyle = {
  color: "blue.500",
  fontWeight: "bold",
  textAlign: "center",
  my: "4",
  cursor: "pointer",
  _hover: { color: "gray" },
};
